export default {
  // General
  'About {appName}': 'Apie {appName}',
  'About Enable Banking API': 'Apie Enable Banking API',
  'Application description is not provided.': 'Programos aprašymas nepateiktas.',
  'Authenticate': 'Autentifikuoti',
  'Authentication method': 'Autentifikavimo metodas',
  'Authentication session has expired': 'Autentifikavimo sesija baigėsi',
  'Cancel': 'Atšaukti',
  'Click {0} button if you have confirmed authorization in the BankID app.': 'Paspauskite {0} mygtuką jei patvirtinote autorizaciją BankID aplikacijoje.',
  'Continue authentication': 'Tęsti autentifikavimą',
  'Cookies must be enabled in your browser to continue': 'Norėdami tęsti, naršyklėje turite įjungti slapukus',
  'Enter your OTP code with index {0}': 'Įvesti OTP kodą su indeksu {0}',
  'Error during authentication:': 'Autentifikavimo klaida:',
  'Error while updating authentication status': 'Autentifikavimo statuso atnaujinimo klaida',
  'OTP code': 'OTP kodas',
  'Open the BankID app on this device': 'Atidaryti BankID aplikaciją šiame įrenginyje',
  'Redirecting to your account servicing provider': 'Nukreipiama į jūsų sąskaitos aptarnavimo teikėją',
  'Returning to the authentication initiator': 'Grįžtama pas autentifikavimo iniciatorių',
  'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page': 'Paleiskite BankID aplikaciją savo mobiliajame įrenginyje ir paspauskite QR kodo mygtuką aplikacijoje, jog nuskenuotumėte šio puslapio QR kodą',
  'or': 'ar',
  'Starting authorization': 'Pradedama autorizacija',
  'To continue please use your authentication app': 'Jog tęstumėte, naudokite autentifikavimo aplikaciją',
  'Try again': 'Bandyti vėl',
  'Submit': 'Įveskite',
  'Unable to access server': 'Serveris nepasiekiamas',
  'Unable to authenticate': 'Autentifikacija negalima',
  'Unable to continue authorization': 'Negalima tęsti autentifikacijos',
  'Unable to continue decoupled authorization': 'Negalima tęsti atsietos autorizacijos',
  'Unable to handle authentication status "{status}"': 'Nepavyksta valdyti autentifikavimo statuso "{status}"',
  'Unknown error occurred': 'Nežinoma klaida',
  'You need to close this window': 'Uždarykite šį langą',
  'Authentication cancelled': 'Autentifikavimas atšauktas',
  // Consent
  'Authentication is initiated by {0}.': 'Autentifikavimas inicijuojamas {0}.',
  'After you complete authentication, {0} will be shared with the authentication initiator.': 'Atlikus autentifikavimą, {0} bus pasidalinta su autentifikavimo iniciatoriumi.',
  'your payment accounts data': 'jūsų mokėjimo sąskaitos duomenimis',
  'the list of your payment accounts': 'jūsų mokėjimo sąskaitų sąrašas',
  'the list of your payment accounts and accounts balances': 'jūsų mokėjimo sąskaitų ir sąskaitų likučių sąrašas',
  'the list of your payment accounts and accounts transactions': 'jūsų mokėjimo sąskaitų ir sąskaitų operacijų sąrašas',
  'the list of your payment accounts, accounts balances and transactions': 'jūsų mokėjimo sąskaitų, sąskaitų likučių ir operacijų sąrašas',
  'By pressing {0} button you agree with the {1}.': 'Paspausdami {0} mygtuką sutinkate su {1}.',
  'Press {0} button if you are not willing to share your payment accounts data.': 'Paspauskite {0} mygtuką jei nesutinkate pasidalinti savo mokėjimų sąskaitos duomenimis.',
  // Payment consent
  'Payment details': 'Mokėjimo detalės',
  'Payment ID provided by the application: {0}': 'Programos pateiktas mokėjimo ID: {0}',
  'Account number where to transfer funds: {0}': 'Sąskaitos numeris, kur pervesti lėšas: {0}',
  'Payee name in the payment: {0}': 'Mokėjimo gavėjo vardas mokėjime: {0}',
  'Payee country: {0}': 'Mokėjimo gavėjo šalis: {0}',
  'Payment amount: {0}': 'Mokėjimo suma: {0}',
  'Message or reference number in the payment: {0}': 'Mokėjimo žinutė arba nuorodos numeris: {0}',
  'Payment is initiated by {0}.': 'Mokėjimą inicijuoja {0}.',
  'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.': 'Kai baigsite autentifikavimą, jūsų sąskaitą aptarnaujantis mokėjimo paslaugų teikėjas paprašys jūsų mokėjimo sutikimo.',
  'terms of service': 'paslaugų teikimo sąlygos',
  'Press {0} button if you are not willing to complete this payment.': 'Jei nenorite atlikti šio mokėjimo, paspauskite mygtuką {0}.',
  'Select Payment Account': 'Pasirinkite mokėjimo sąskaita',
  'Confirm': 'Patvirtinti',
  // Backend messages
  '10 digit client number': '10 skaitmenų kliento numeris',
  '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)': '10 skaitmenų organizacijos numeris (arba 12 skaitmenų asmens numeris, jei įmonė yra individuali įmonė)',
  '10 digit organization number.': '10 skaitmenų organizacijos numeris.',
  '17 digit card number (starting with 6703)': '17 skaitmenų kortelės numeris (pradedant 6703)',
  '6 digit Handelsbanken customer number': '6 skaitmenų Handelsbanken kliento numeris',
  '8 digits CVR number': '8 skaitmenų CVR numeris',
  '9 digits Organisasjonsnummer': '9 skaitmenų Organisasjonsnummer',
  'Agreement number': 'Sutarties numeris',
  'Agreement number for Nordea Corporate Netbank': 'Nordea korporatyvinio internetinio banko sutarties numeris',
  'Bank user ID': 'Banko vartotojo ID',
  'Business identity code (Y-tunnus) in 1234567-8 format': 'Įmonės tapatybės kodas (Y-tunnus) 1234567-8 formatu',
  'Business identity code which is displayed in the Corporate Internet bank settings': 'Įmonės tapatybės kodas, kuris rodomas Įmonės interneto banko nustatymuose',
  'Client ID': 'Kliento ID',
  'Client number': 'Kliento numeris',
  'Company ID': 'Įmonės ID',
  'Company number': 'Įmonės numeris',
  'Corporate ID': 'Įmonės ID',
  'Corporate registration ID': 'Įmonės registracijos ID',
  'Currency code': 'Valiutos kodas',
  'Digit card number': 'Skaitmeninis kortelės numeris',
  'Disposer': 'Šalintuvas',
  'E-mail': 'El. paštas',
  'E-mail used for authenticating to Holvi': 'El. paštas naudojamas Holvi autentifikavimui',
  'Either the 14 digit SEB identifier for the company or the 10 digit organization number': 'Arba 14 skaitmenų įmonės SEB identifikatorius arba 10 skaitmenų organizacijos numeris',
  'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number': 'FKDN (be subsąskaitos numerio): 3 skaitmenų filialo numeris + 7 skaitmenų kliento numeris',
  'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.': 'Švedijos įmonėms tai yra organizacijos numeris arba SHB numeris, o individualiems prekiautojams (Enskild firma) – asmeninis numeris, kurį sudaro 10 skaitmenų.',
  'IBAN': 'IBAN',
  'ID, NIE, Passport': 'ID, NIE, pasas',
  'Login ID used in MyBRD aplications': 'MyBRD programose naudojamas prisijungimo ID',
  'Login Name': 'Prisijungimo vardas',
  'Mandate ID': 'Mandato ID',
  'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)': 'Norvegijos nacionalinis asmens kodas DDMMYYXXXXX formatu (11 skaitmenų)',
  'Online banking PIN': 'Internetinės bankininkystės PIN kodas',
  'Online banking Password': 'Internetinės bankininkystės slaptažodis',
  'Organisation ID in the format TBxxxxx or TXxxxxx': 'Organizacijos ID formatu TBxxxxx arba TXxxxxx',
  'Organisation number': 'Organizacijos numeris',
  'PIN': 'PIN kodas',
  'Password': 'Slaptažodis',
  'Password for Aktia Internet bank': 'Aktia interneto banko slaptažodis',
  'Password used for authenticating to Holvi': 'Slaptažodis, naudojamas autentifikuoti Holvi',
  'Personal ID': 'Asmens ID',
  'Personal ID number': 'Asmens ID numeris',
  'Personal code': 'Asmens kodas',
  'Personal code of the user': 'Vartotojo asmeninis kodas',
  'Personal signatory number': 'Asmeninis parašo numeris',
  'Personal username for online banking': 'Asmeninis prisijungimo vardas internetinei bankininkystei',
  'Postbank ID': 'Pašto banko ID',
  'Social security number (Personnummer)': 'Socialinio draudimo numeris (Personnummer)',
  'Social security number in the format YYYYMMDDXXXX': 'Socialinio draudimo numeris formatu YYYYMMDDXXXX',
  'Swedish social security number in the format YYYYMMDDXXXX': 'Švedijos socialinio draudimo numeris YYYYMMDDXXXX formatu',
  'The IBAN of the user authenticating': 'Autentifikuojančio vartotojo IBAN',
  'The currency code': 'Valiutos kodas',
  'The user ID of the user authenticating': 'Autentifikuojančio vartotojo ID',
  'Unique personal ID number': 'Unikalus asmens kodas',
  'User ID': 'Vartotojo ID',
  'User ID for Aktia Internet bank': 'Aktia interneto banko vartotojo ID',
  'User ID for Nordea Corporate Netbank': 'Nordea Corporate Internetbank vartotojo ID',
  'User ID for online banking': 'Internetinės bankininkystės vartotojo ID',
  'User ID in the format XX000000': 'Vartotojo ID formatu XX000000',
  'User ID used to log in to the bank': 'Vartotojo ID, naudojamas prisijungiant prie banko',
  'Username': 'Vartotojo vardas',
  'Username used to log in to the bank': 'Vartotojo vardas, naudojamas prisijungiant prie banko',
  'VR NetKey': 'VR NetKey',
  'WebSSO user name': 'WebSSO vartotojo vardas',
}
